import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api, formatErr } from "../lib/api";

export default function Reset() {
    const [sp] = useSearchParams();
    const tokenFromUrl = sp.get("token") || "";
    const [token, setToken] = useState(tokenFromUrl);
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [done, setDone] = useState(false);
    const nav = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        try {
            await api.post("/auth/reset-password", { token, password });
            setDone(true);
            setTimeout(() => nav("/login"), 1500);
        } catch (er) {
            setErr(formatErr(er.response?.data?.detail) || er.message);
        }
    };

    return (
        <div className="min-h-screen grain grid place-items-center p-6" data-testid="reset-page">
            <form onSubmit={submit} className="w-full max-w-sm card-warm p-7 fade-up">
                <div className="font-serif text-2xl mb-1">Reset password</div>
                <div className="text-sm text-[var(--text-ink)]/65 mb-5">Choose a new password for your account.</div>
                {!tokenFromUrl && (
                    <>
                        <label className="text-sm">Reset token</label>
                        <input required value={token} onChange={(e) => setToken(e.target.value)} data-testid="reset-token"
                               className="w-full mb-3 px-3 py-2 rounded-xl border border-[rgba(26,19,24,0.15)]" />
                    </>
                )}
                <label className="text-sm">New password</label>
                <input required type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
                       data-testid="reset-password"
                       className="w-full mt-1 px-3 py-2 rounded-xl border border-[rgba(26,19,24,0.15)] focus:outline-none focus:border-[var(--brand-purple)]" />
                <button type="submit" data-testid="reset-submit-btn" className="btn-primary w-full mt-4">Reset</button>
                {done && <div className="text-sm text-[var(--status-green)] mt-3" data-testid="reset-success">Done! Redirecting to sign in…</div>}
                {err && <div className="text-sm text-[var(--status-red)] mt-3">{err}</div>}
                <Link to="/login" className="block text-sm text-center mt-4 text-[var(--text-ink)]/70 hover:underline">Back to sign in</Link>
            </form>
        </div>
    );
}
